(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carlotta-product-video"] && !Shopify.designMode) return;
  try {
    
function initCarlottaVideo(){
document.querySelectorAll('[data-cm-video]').forEach(root=>{
if(root.dataset.ready)return;
root.dataset.ready='true';
const video=root.querySelector('video'),button=root.querySelector('button');
let userPaused=false;
video.muted=true;
function start(){if(!userPaused)video.play().catch(()=>{button.textContent=button.dataset.play;});}
video.addEventListener('play',()=>button.textContent=button.dataset.pause);
video.addEventListener('pause',()=>button.textContent=button.dataset.play);
button.addEventListener('click',()=>{if(video.paused){userPaused=false;start();}else{userPaused=true;video.pause();}});
new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting)start();});},{rootMargin:'300px'}).observe(root);
document.addEventListener('visibilitychange',()=>{if(!document.hidden)start();});
start();
});
}
initCarlottaVideo();
document.addEventListener('shopify:section:load',initCarlottaVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlotta-reference-header"] && !Shopify.designMode) return;
  try {
    

const cmRomeClock=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
function cmRomeParts(date){return Object.fromEntries(cmRomeClock.formatToParts(date).filter(part=>part.type!=='literal').map(part=>[part.type,Number(part.value)]));}
function cmNextRomeMidnight(date){const parts=cmRomeParts(date);const target=Date.UTC(parts.year,parts.month-1,parts.day+1);let guess=target;for(let i=0;i<3;i++){const local=cmRomeParts(new Date(guess));const wallTime=Date.UTC(local.year,local.month-1,local.day,local.hour,local.minute,local.second);guess+=target-wallTime;}return guess;}
function cmUpdateDailyCountdown(){const now=new Date();const remaining=Math.max(0,Math.floor((cmNextRomeMidnight(now)-now.getTime())/1000));const values={hours:Math.floor(remaining/3600),minutes:Math.floor(remaining%3600/60),seconds:remaining%60};document.querySelectorAll('[data-cm-daily-countdown]').forEach(timer=>{for(const [unit,value] of Object.entries(values)){timer.querySelector('[data-cm-'+unit+']').textContent=String(value).padStart(2,'0');}timer.hidden=false;});}
cmUpdateDailyCountdown();setInterval(cmUpdateDailyCountdown,1000);document.addEventListener('DOMContentLoaded',cmUpdateDailyCountdown);document.addEventListener('shopify:section:load',cmUpdateDailyCountdown);document.addEventListener('visibilitychange',cmUpdateDailyCountdown);


document.addEventListener('pointerover',event=>{
 if(event.pointerType!=='mouse'||!window.matchMedia('(hover: hover) and (pointer: fine)').matches)return;
 const detail=event.target.closest('.cm-nav details');if(!detail)return;
 document.querySelectorAll('.cm-nav details[open]').forEach(other=>{if(other!==detail&&!other.contains(detail)&&!detail.contains(other))other.open=false;});
 let current=detail;while(current&&current.closest('.cm-nav')){current.open=true;current=current.parentElement.closest('details');}
});
document.addEventListener('pointerout',event=>{
 if(event.pointerType!=='mouse'||!window.matchMedia('(hover: hover) and (pointer: fine)').matches)return;
 const detail=event.target.closest('.cm-nav details');if(!detail||detail.contains(event.relatedTarget))return;
 if(detail.contains(document.activeElement)&&document.activeElement!==detail.querySelector('summary'))return;
 detail.open=false;detail.querySelectorAll('details[open]').forEach(child=>child.open=false);
});
document.addEventListener('click',event=>{const header=event.target.closest('.cm-header');document.querySelectorAll('.cm-nav__dropdown[open],.cm-search[open],.cm-mobile-menu[open]').forEach(d=>{if(!d.contains(event.target))d.removeAttribute('open');});if(!header)return;});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.cm-header details[open]').forEach(d=>d.removeAttribute('open'));});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlotta-reference-popup"] && !Shopify.designMode) return;
  try {
    

function cmInitPopup(){
 const popup=document.querySelector('[data-cm-popup]');if(!popup||popup.dataset.initialized)return;popup.dataset.initialized='true';
 const key='carlotta-newsletter-last-shown';const close=()=>{popup.close();try{localStorage.setItem(key,String(Date.now()));}catch(e){}};
 popup.querySelectorAll('[data-cm-popup-close]').forEach(button=>button.addEventListener('click',close));
 popup.addEventListener('click',event=>{if(event.target===popup){const r=popup.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}});
 popup.addEventListener('cancel',()=>{try{localStorage.setItem(key,String(Date.now()));}catch(e){}});
 let last=0;try{last=Number(localStorage.getItem(key)||0);}catch(e){}
 if(document.documentElement.classList.contains('shopify-design-mode'))return;
 if(Date.now()-last>86400000)setTimeout(()=>{if(!document.querySelector('dialog[open]'))popup.showModal();},8000);
}
cmInitPopup();document.addEventListener('shopify:section:load',cmInitPopup);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carlotta-reference-reviews"] && !Shopify.designMode) return;
  try {
    

function cmUpdateReviewButtons(section){const track=section.querySelector('.cm-reviews__track');if(!track)return;const previous=section.querySelector('[data-cm-review-dir="-1"]');const next=section.querySelector('[data-cm-review-dir="1"]');if(previous)previous.disabled=track.scrollLeft<2;if(next)next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;}
function cmInitReviews(){document.querySelectorAll('.cm-reviews').forEach(section=>{const track=section.querySelector('.cm-reviews__track');if(!track)return;cmUpdateReviewButtons(section);if(track.dataset.cmReviewReady)return;track.dataset.cmReviewReady='true';track.addEventListener('scroll',()=>cmUpdateReviewButtons(section),{passive:true});});}
cmInitReviews();document.addEventListener('DOMContentLoaded',cmInitReviews);document.addEventListener('shopify:section:load',cmInitReviews);window.addEventListener('resize',cmInitReviews);
document.addEventListener('click',event=>{const button=event.target.closest('[data-cm-review-dir]');if(!button)return;const section=button.closest('.cm-reviews');const track=section.querySelector('.cm-reviews__track');const card=track.querySelector('.cm-review');const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0);track.scrollBy({left:step*Number(button.dataset.cmReviewDir),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});


  } catch(e) { console.error(e); }
})();
})();
